module.exports = __webpack_public_path__ + "static/img/t8.80d868e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t8.png
// module id = rsVE
// module chunks = 1